import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ListItem } from '../../../../Components/List';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import IconBtn from '../../../../Components/IconBtn';

import SelectByTypeCategories from './SelectByTypeCategories';

export function ProductItem({
	id,
	onDelete,
	item,
	isFiltered,
	onSelectCategory
}) {
	
	const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({ id: id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		zIndex: isDragging ? '1000' : 'auto',
	};

	const result = item.categories.map(item => ({
		label: `${item._type} : ${item._name} `,
		value: item._key,
		cat1 : item._type,
		cat2 : item._name
	}));

	return (
		<ListItem
			className="flex"
			ref={setNodeRef}
			text={item.name}
			textIsBold={false}
			description={item.id}
			picto={
				<ProductThumb
					url={item.urlThumbnail}
					alt={item.name}
					hasMargin={false}
					width={50}
				/>
			}
			actions={
				<>
					<SelectByTypeCategories 
						changeCategorySelected={onSelectCategory}
						categories={result}
					/>
					<IconBtn
						onClick={() => onDelete(item.id)}
						icon="fas fa-trash"
						tooltip="Remove product"
						hoverColor="alert"
					/>
				</>
			}
			style={{ ...style }}
			isDragging={isDragging}
			dragHandle={
				!isFiltered &&
					<IconBtn
						icon="fas fa-equals"
						tooltip="Reorder products"
						{...listeners}
					/>
			}
			{...attributes}
		>
			{/* {item.categories && item.categories.length > 0 ? (
				item.categories.map((rayon) => (
					<div key={rayon._key} className='s_13 grey_3 mt_3' >
						<span>Type: {rayon._type}
							<strong> {rayon._name} </strong>
						</span>
					</div>
				))
			) : null} */}
		</ListItem>
	);
}